exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table-operator[data-v-bee78ac2] { margin-bottom: 15px;\n}\n", ""]);

// exports
